import React from "react"
import Select from "react-select"
import _ from "lodash"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"

class PropertySelect extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			menuIsOpen: false,
			controlHeld: false, // for property select, hold down ctrl for multiple
			controlProperties: [],
		}
	}

	componentDidMount() {
		window.addEventListener("keydown", this.downHandler)
		window.addEventListener("keyup", this.upHandler)
		this.setState({controlProperties: this.props.activeProperties})
	}

	componentDidUpdate(prevProps) {
		if (prevProps.controlKey !== this.props.controlKey && !this.props.controlKey) {
			this.handleBlur()
		}
	}

	handleChange = (value, obj) => {
		if (value === null) {
			value = []
		}
		let f = []
		for (let r of value) {
			if (r.metro) {
				// this is a metro, run through that process
				_.forEach(this.props.options[0].options, (v) => {
					// this is always the individual communities...[0]....r is if they choose "houston"...r.group is 1, v is the community
					if (v.metroGroup == r.group) {
						f.push(v.value)
					}
				})
			} 
			else if(r.county) {
				// this is for a county selection
				_.forEach(this.props.options[0].options, (v) => {
					if (v.countyGroup === r.group) {
						f.push(v.value)
					}
				})
			}
			else if (r.metroSub) {
				// this is for a metro subgroup....see above
				_.forEach(this.props.options[0].options, (v) => {
					if (v.metroSubGroup == r.group) {
						f.push(v.value)
					}
				})
			} else if (r.value == "*") {
				// all communities
				_.forEach(this.props.options[0].options, (v) => {
					// this is always the individual communities...[0]....r is if they choose "houston"...r.group is 1, v is the community
					f.push(v.value)
				})
			}
			else if(r.developer) {
				// This is for the special developer designations, JDS vs JDC
				_.forEach(r.value, (v) => {
					f.push(v)
				})
			}
			else {
				// this is a regular community selection
				f.push(r.value)
			}
		}
		f = _.uniq(f)
		this.props.onChange(f, this.state.controlHeld)
		if (!this.state.controlHeld) this.handleBlur()
	}

	handleBlur = () => {
		this.setState({ menuIsOpen: false })
		this.selectRef.blur()
	}

	pickValue = (opts, values) => {
		let arr = []
		_.forEach(opts, (groups) => {
			_.forEach(groups.options, (row) => {
				if (values.includes(row.value)) {
					arr.push(row)
				}
			})
		})
		return arr
	}

	downHandler = (e) => {
		if (this.state.menuIsOpen && !e.repeat && (e.key == "Control" || e.key == "Meta")) {
			this.setState({ controlHeld: true, controlProperties: this.props.activeProperties })
		}
	}

	upHandler = ({ key }) => {
		if (this.state.menuIsOpen && (key == "Control" || key == "Meta")) {
			this.setState({ controlHeld: false })
			if (this.props.activeProperties !== this.state.controlProperties) {
				this.props.getPayload()
				this.setState({ controlProperties: this.props.activeProperties })
				this.handleBlur()
			}
		}
	}

	onFocus = () => {
		this.setState({ menuIsOpen: true })
		this.selectRef.focus()
	}

	render() {
		return (
			<>
				<Select
					className={this.props.className ? this.props.className : "form__input"}
					classNamePrefix={this.props.classNamePrefix}
					value={this.pickValue(this.props.options, this.props.value)}
					id={this.props.name}
					options={this.props.options}
					onChange={(v, obj) => this.handleChange(v, obj)}
					onBlur={this.handleBlur}
					isMulti={this.props.isMulti}
					isClearable={this.props.clearable}
					menuIsOpen={this.state.menuIsOpen}
					onFocus={this.onFocus}
					blurInputOnSelect={false}
					ref={(el) => (this.selectRef = el)}
				/>
			</>
		)
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(PropertySelect)